import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import useScreenSize from '../../../util/hooks/useScreenSize';

const SectionHeadingLoadingSkeleton = () => {
  const { isMobile, isTablet } = useScreenSize();
  if (isMobile || isTablet) {
    return (
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Skeleton height={100} variant="text" width="100%" />
          </Grid>
        </Grid>
      </Container>
    );
  }
  return (
    <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Grid container spacing={2} sx={{ position: 'relative' }}>
        <Grid size={{ md: 8, xs: 12 }}>
          <Skeleton height="130px" sx={{ borderRadius: 2 }} variant="rounded" width="100%" />
        </Grid>
        <Grid size={{ md: 4, xs: 12 }} sx={{ position: 'absolute', top: 0, right: 0, width: '100%' }}>
          <Box sx={{ backgroundColor: '#fff' }}>
            <Skeleton height="640px" sx={{ borderRadius: 2 }} variant="rounded" width="100%" />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SectionHeadingLoadingSkeleton;